export default __webpack_public_path__ + "static/media/trophy.bab1d7ab.svg";